export const NUMBER_OF_PERSONS_TO_SEARCH = 20;
export const NUMBER_OF_ORGANIZATIONS_TO_SEARCH = 20;
export const NUMBER_OF_ACTIVITIES_TO_SEARCH = 20;
export const MULTI_ITEM_FILTER_TYPES: string[] = ['consentTypes', 'attributes'];
